import axios from "axios";
import { logout } from "../utils";

interface GetProps {
  url: string;
  signal?: AbortSignal;
}

interface PostProps extends GetProps {
  data: unknown;
}

const headers = {
  "Content-Type": "application/json",
};

const withCredentials = true;

// rethrowAfterLogout logs the user out on a 401 (except for /auth/ calls) and rethrows.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const rethrowAfterLogout = (url: string) => (err: any) => {
  if (err?.response?.status === 401 && !url.startsWith("/auth/")) {
    logout();
  }
  throw err;
};

export const Get = <T>({ url, signal }: GetProps): Promise<void | T> => {
  return axios
    .get(url, {
      signal,
      headers: { ...headers, Authorization: localStorage.getItem("token") },
      withCredentials,
    })
    .then((response) => {
      return response.data?.data as T;
    })
    .catch(rethrowAfterLogout(url));
};

export const Post = <T>({
  url,
  signal,
  data,
}: PostProps): Promise<void | T> => {
  return axios
    .post(url, data, {
      signal,
      headers: { ...headers, Authorization: localStorage.getItem("token") },
      withCredentials,
    })
    .then((response) => {
      return response.data?.data as T;
    })
    .catch(rethrowAfterLogout(url));
};

export const Delete = <T>({ url, signal }: GetProps): Promise<void | T> => {
  return axios
    .delete(url, {
      signal,
      headers: { ...headers, Authorization: localStorage.getItem("token") },
      withCredentials,
    })
    .then((response) => {
      return response.data?.data as T;
    })
    .catch(rethrowAfterLogout(url));
};

export const DownloadExcel = ({ data, url }: PostProps) => {
  return axios({
    method: "post",
    url: url,
    data: data,
    responseType: "arraybuffer",
    withCredentials: true,
  });
};
